module.exports = __webpack_public_path__ + "img/user.e14e0574.png";